 export default {
     data() {
         return {
             idNumber: "",
             canSearch: false,
             certificates: [], // 证书列表（按颁发时间倒序）
             activeId: null, // 当前展开详情的证书id
             searched: false // 是否已执行过查询（用于空状态展示）
         }
     },
     mounted: function () {
         let key = this.$route.query.key;
         if (key != null && key != undefined && (key.length == 15 || key.length == 18)) {
             this.idNumber = key;
             this.search();
         }
     },
     methods: {
         onIptChange: function (e) {
             this.canSearch = this.idNumber.length == 15 || this.idNumber.length == 18;
         },
         formateDate: function (date) {
             if (date == null || date.length < 10) return date;
             return date.substring(0, 10);
         },
         // 证书到期时间：分数>=90有效期2年，否则1年
         // “-”替换为“/”以兼容iOS/微信WebView对“yyyy-MM-dd HH:mm:ss”的解析
         getExpireDate: function (certificate) {
             if (certificate.toDate) {
                 return new Date(String(certificate.toDate).replace(/-/g, "/"));
             }
             var date = new Date(String(certificate.createDate).replace(/-/g, "/"));
             date.setFullYear(date.getFullYear() + (certificate.score >= 90 ? 2 : 1));
             return date;
         },
         isExpired: function (certificate) {
             var time = this.getExpireDate(certificate).getTime();
             return isNaN(time) ? false : time < new Date().getTime();
         },
         formatExpireDate: function (certificate) {
             var date = this.getExpireDate(certificate);
             if (isNaN(date.getTime())) return "";
             var month = date.getMonth() + 1;
             var day = date.getDate();
             return date.getFullYear() + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
         },
         toggle: function (item) {
             this.activeId = this.activeId === item.id ? null : item.id;
         },
         forceReflow: function (el) {
             return el.offsetHeight;
         },
         // 详情展开/收起高度过渡
         onDetailEnter: function (el) {
             el.style.height = "0";
             this.forceReflow(el);
             el.style.height = el.scrollHeight + "px";
         },
         onDetailAfterEnter: function (el) {
             el.style.height = "";
             if (el.parentElement)
                 el.parentElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
         },
         onDetailLeave: function (el) {
             el.style.height = el.scrollHeight + "px";
             this.forceReflow(el);
             el.style.height = "0";
         },
         onDetailAfterLeave: function (el) {
             el.style.height = "";
         },
         search: function () {
             if (this.idNumber.length != 15 && this.idNumber.length != 18) {
                 this.$message.warning("身份证号有误");
                 return;
             }
             this.$post({
                 url: "certificate_record/queryList",
                 params: {
                     idNumber: this.idNumber
                 }
             }, true).then(res => {
                 this.certificates = res == null ? [] : res;
                 this.searched = true;
                 // 仅一本证书时自动展开（保持原直接查看体验），多本时点击后展开
                 this.activeId = this.certificates.length > 0 ? this.certificates[0].id : null;
             }).catch(err => {
                 this.certificates = [];
                 this.activeId = null;
                 this.searched = true;
             });
         }
     }
 }
